import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Oralia',
    image: 'https://cdn.magicpatterns.com/uploads/t7SRWdSfKzYNUGx9o6PEeb/heylloyd-image-1778072675296.png',
    quote: 'Llevaba meses sintiéndome culpable cada vez que comía algo rico. Con este método entendí que no necesitaba eliminar todo, solo hacer mejores cambios. Las recetas son fáciles y por primera vez quiero repetirlas.'
  }, {
    name: 'Juan Luis',
    image: 'https://cdn.magicpatterns.com/uploads/sQY4nMxpWQrLLamJcUatwk/heylloyd-image-1778073029579.png',
    quote: 'La parte de restaurantes me cambió la dinámica completamente. Antes salía a comer y sentía que perdía el control. Ahora sé qué elegir y disfruto más sin esa presión.'
  }, {
    name: 'Ana Lucía',
    image: 'https://cdn.magicpatterns.com/uploads/jGopZuc8prmNWzk2tmNySg/heylloyd-image-1778073776140.png',
    quote: 'Siempre caía en el todo o nada: o dieta perfecta o me olvidaba de todo. Este libro me dio opciones simples para los días difíciles. Ya no me siento tan perdida cuando tengo ansiedad o poco tiempo.'
  }];
  return <section className="py-24 bg-white border-b border-gray-100" data-id="element-283">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-284">
        <FadeIn data-id="element-285">
          <div className="text-center mb-16" data-id="element-286">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-warm-brown mb-6" data-id="element-287">
              Historias Reales
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-288">
              Personas que ya están comiendo mejor sin renunciar a su vida
              social.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-289">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-290">
              <div className="bg-cream rounded-3xl p-8 shadow-md border border-warm-beige h-full flex flex-col relative" data-id="element-291">
                {testimonial.image ? <div className="flex justify-center mb-4" data-id="element-292">
                    <img src={testimonial.image} alt={testimonial.name} className="w-20 h-20 rounded-full object-cover border-4 border-white shadow-md" data-id="element-293" />
                  </div> : <div className="flex justify-center mb-4" data-id="element-294">
                    <div className="w-20 h-20 rounded-full bg-olive-green/20 flex items-center justify-center text-olive-green font-bold text-2xl border-4 border-white shadow-md" data-id="element-295">
                      {testimonial.name.charAt(0)}
                    </div>
                  </div>}

                <div className="flex justify-center text-yellow-400 mb-6" data-id="element-296">
                  {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-297" />)}
                </div>

                <div className="flex-grow" data-id="element-298">
                  <p className="text-gray-700 text-lg leading-relaxed mb-8 text-center" data-id="element-299">
                    "{testimonial.quote}"
                  </p>
                </div>

                <div className="mt-auto pt-6 border-t border-gray-200 text-center" data-id="element-300">
                  <p className="font-bold text-gray-900 text-lg" data-id="element-301">
                    {testimonial.name}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}